import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 bg-light p-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Rate Range List")
  ])
], -1)
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table table-striped table-sm" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "#"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Start Range"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "End Range"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Range Price"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Rate Type"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Action")
  ])
], -1)
const _hoisted_8 = { class: "text-start" }
const _hoisted_9 = { class: "text-start" }
const _hoisted_10 = { class: "text-start" }
const _hoisted_11 = { class: "text-start" }
const _hoisted_12 = { class: "text-start" }
const _hoisted_13 = { class: "text-start" }
const _hoisted_14 = { class: "btn-group mr-2" }
const _hoisted_15 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AdminPagination = _resolveComponent("AdminPagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("table", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.rateranges, (raterange) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: raterange.id
                  }, [
                    _createElementVNode("td", _hoisted_8, _toDisplayString(raterange.id), 1),
                    _createElementVNode("td", _hoisted_9, _toDisplayString(raterange.start_range), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(raterange.end_range), 1),
                    _createElementVNode("td", _hoisted_11, _toDisplayString(raterange.range_price), 1),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(raterange.rate_price_type), 1),
                    _createElementVNode("td", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_router_link, {
                          to: `/rateranges/${raterange.id}/edit`,
                          class: "btn btn-sm btn-secondary me-2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Edit")
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        _createElementVNode("a", {
                          class: "btn btn-sm btn-danger me-2",
                          onClick: ($event: any) => ($setup.del(raterange.id))
                        }, " Delete", 8, _hoisted_15)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_AdminPagination, {
      "last-page": $setup.lastPage,
      onPageChanged: _cache[0] || (_cache[0] = ($event: any) => ($setup.load($event)))
    }, null, 8, ["last-page"])
  ], 64))
}